// extracted by mini-css-extract-plugin
export default {"active":"LangSelect_active__aTvYY","lang_box":"LangSelect_lang_box__wrk4J","icon":"LangSelect_icon__-Dz5E"};